import $ from 'jquery';
import _ from 'lodash';
import module from 'module';

const templateUrl = require('./calculate-auction-price.template.html');
const auctionTagPath = `/dashboard/appraisals/auction-tag`;
const pawnedItemsListPath = `/dashboard/appraisals`;

class CalculateAuctionPrice {
  constructor($routeParams, http, pawnStatusMapper, pawnItemTypeCache, $location, reportModal,
              branchService, pawnAuctionCache, pawnMetalDescriptionService,
              modalInfo, command, pawnItemCache, pawnCache, popup, commandAccessChecker) {
    this.$routeParams = $routeParams;
    this.http = http;
    this.pawnStatusMapper = pawnStatusMapper;
    this.pawnItemTypeCache = pawnItemTypeCache;
    this.$location = $location;
    this.reportModal = reportModal;
    this.branchService = branchService;
    this.pawnAuctionCache = pawnAuctionCache;
    this.pawnMetalDescriptionService = pawnMetalDescriptionService;
    this.modalInfo = modalInfo;
    this.command = command;
    this.pawnItemCache = pawnItemCache;
    this.pawnCache = pawnCache;
    this.popup = popup;
    this.commandAccessChecker = commandAccessChecker;
  }

  async $onInit() {
    if (this.$routeParams && this.$routeParams.selectedIds) {
      let ids = this.$routeParams.selectedIds;
      if (!Array.isArray(ids)) {
        ids = [ids];
      }
      this.selectedIds = ids.map(Number);
    }

    this.selectedBranchId = Number(this.$routeParams.selectedBranchId);

    this.pawnItemTypes = [];
    this.pawnItems = [];

    this.doneGeneratingAuctionReport = false;

    this.branchService.toObservable().subscribe(branches => {
      this.branches = branches;
    });

    this.pawnAuctionCache.systemAuctions().toObservable().subscribe(auctions => {
      this.auctions = auctions;
    });

    // Read pawn item types
    this.pawnItemTypeCache.toObservable().subscribe(itemTypes => {
      this.pawnItemTypes = itemTypes;
    });

    await this.fetchPawnItemsWithCalculatedAuctionPrices();
  }

  async fetchPawnItemsWithCalculatedAuctionPrices() {
    if (!this.selectedIds || this.selectedIds.length === 0) {
      return;
    }

    await this.http.get(`/products/pawns/items-with-calculated-auction-price?ids=${this.selectedIds}&branchId=${this.selectedBranchId}`)
      .success((response) => {
        this.pawnItems = response;

        // For each pawn item prepare item details
        if (this.pawnItems && this.pawnItems.length > 0) {
          _.forEach(this.pawnItems, (obj) => {
            // calculate box number
            obj.item.boxNumber = obj.item.withdrawBox ? obj.item.withdrawBox.branchId + '-'
              + obj.item.withdrawBox.boxNumber : null;

            // Extend item with category/type/subtype labels
            Object.assign(obj.item, {categoryLabel: this.getTypeLabel(obj.item.categoryId)});
            Object.assign(obj.item, {typeLabel: this.getTypeLabel(obj.item.typeId)});
            Object.assign(obj.item, {subtypeLabel: this.getTypeLabel(obj.item.subtypeId)});
            // Extend item with details pane data
            if (!obj.pawn) {
              Object.assign(obj.pawn, {
                auctionDate: '-',
                expirationDate: '-',
                productNumber: '-'
              });
            }
          })
        }
      });
  }

  getTypeLabel(typeId) {
    let type = _.find(this.pawnItemTypes, {id: typeId});
    return type && type.name ? type.name : '-';
  };

  generateAuctionTag() {
    this.$location.path(auctionTagPath).search({
      selectedIds : this.selectedIds,
      selectedBranchId: this.selectedBranchId
    });
  }

  generateAuctionReport() {
    let params = {
      ids: this.selectedIds,
      branchId: this.selectedBranchId
    };
    let reportName = 'AuctionItemsReport';
    this.reportModal.display({
      params: params,
      reportCode: reportName,
      hideXls: true
    });
    this.doneGeneratingAuctionReport = true;
  }

  getAuctionNamesForCurrentBranch() {
    const auctions = _.filter(this.auctions, a => this.selectedIds.includes(a.id))
    return auctions != null ? auctions.map(a => a.name).join(", ") : null;
  }

  withdrawAction() {
    const branch = _.find(this.branches, {id: this.selectedBranchId}, 0);
    const branchName = branch != null ? branch.name : null;
    const auctionsName = this.getAuctionNamesForCurrentBranch();

    const content = this.pawnMetalDescriptionService.buildSelectedItemsInfo(
      branchName,
      auctionsName,
      this.selectedIds
    );

    const buttons = [{
      text: 'Withdraw',
      action: async () => {
        this.modalInfo.closeModalWithBackdrop();

        let res;

        const canExecuteCommand = await this.commandAccessChecker.canExecuteCommandPromise();
        if (canExecuteCommand('WithdrawAuctionedItems')) {
          res = await this.command.execute('WithdrawAuctionedItems', {
            itemIds: this.selectedIds
          }).toPromise();
        } else {
          res = await this.command.execute('WithdrawPawnItem', {
            itemIds: this.selectedIds,
            allowAuctionedPawns: true
          }).toPromise();
        }

        if (!res || res.approvalRequired) {
          return;
        }

        this.pawnItemCache.evict();
        this.pawnCache.evict();

        this.popup({
          text: `Created box number: ${branch.id + '-' + res.output.id}`,
          callback: () => {
            this.$location.path(`/dashboard/appraisals`);
          }
        });
      },
      bclass: 'btn btn-primary'
    }];

    this.modalInfo.display(
      content,
      "Pawned items selected for withdraw",
      `Do you want to withdraw ${this.selectedIds.length} items to head office?`,
      buttons);
  };

  goBack() {
    this.$location.path(pawnedItemsListPath).search({});
  }

  $onDestroy() {
    if (this.selectedIds && this.$location.path() !== auctionTagPath) {
      this.$location.search({});
    }
  }
}

module.component('calculateAuctionPrice', {
  templateUrl: templateUrl,
  controller: CalculateAuctionPrice
});